import { LandingPad } from "../models/landing-pad.interface";
import { Order } from "@m4a3/api-client";

export const getPadNameThatAircraftIsAssignedTo = (ac: string | null, pads: LandingPad[]): string => {
  const aircraftId = parseInt(ac?.replace('MNA-', ''));
  return pads.find(p => p.aircraft === aircraftId)?.name || '';
};

/**
 * Get all active pads available for an order, with special business logic for different order types, 
 * or filtered by landing zone then cellId if no special business logic is needed with a fallback to all active pads
 */
export const getAllActivePadsForOrder = (order: Order, pads: any[]): any[] => {
  if (!pads) return [];
  
  // Special filtering for JUSTEAT orders with BT_A landing pad
  const isJustEatOrder = order?.externalProviderName === 'JUSTEAT';
  const selectedPadName = pads.find(pad => pad.id === order.destinationLandingPadId)?.name;
  
  if (isJustEatOrder && selectedPadName === 'BT_A') {
    // For JUSTEAT orders with BT_A, only show BT_A and J6_B as options
    return pads.filter(pad => 
      pad.active === true && 
      pad.cellId === order.cellId &&
      (pad.name === 'BT_A' || pad.name === 'J6_B')
    );
  }

  // Filter pads to only show those in the order's landing zone if available
  if (order?.landingZoneId) {
    return pads.filter(pad => 
      pad.active === true && 
      pad.landingZoneId === order.landingZoneId
    );
  }
  
  // Fallback to cell-based filtering if landing zone is not available
  if (order?.cellId) {
    return pads.filter(pad => 
      pad.active === true && 
      pad.cellId === order.cellId
    );
  }
  
  // Final fallback to all active pads
  return pads.filter(pad => pad.active === true);
};
